import { render, staticRenderFns } from "./visit-manage.vue?vue&type=template&id=7b8946a6"
import script from "./visit-manage.vue?vue&type=script&lang=ts"
export * from "./visit-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports